import React from "react";
import dynamic from "next/dynamic";
import DisplayOnViewportIntersection from "@/bit/components/next13.components.display-on-viewport-intersection";
import CustomizerComponent from "@/bit/components/next13.components.customizer-component";
import CustomizerComponentB from "@/bit/components/next13.components.customizer-component";
import MetaData from "@/bit/core/next13.core.meta-data";
import Header from "@/bit/components/next13.components.header";
import Footer from "@/bit/components/next13.components.footer";
import { wrapper } from "store";
import { END } from "redux-saga";
import Banner from "@/component/banner";
import FeaturedOffer from "@/component/featured-offer";
import DeviceSection from "@/component/devices-section";
import Teletipo from "@/component/teletipo";
const AdvantagesSection = dynamic(() =>
  import("@/component/advantages-section")
);
const StreamingPlatformsSection = dynamic(() =>
  import("@/component/streaming-platforms-section")
);
const Ecosystem = dynamic(() => import("@/component/ecosystem"));

const Home = (props) => {
  const {
    breadcrumbsProps,
    footerProps,
    headerProps,
    seoInfo,
    // creatividades
    dispoData,
    banner1,
    banner2,
    banner3,
    offerTitle,
    offer1,
    offer2,
    offer3,
    offer4,
    sliderContenidos,
    creativityData10,
    advantages,
    creativityData13,
  } = props;
  return (
    <>
      <MetaData seoInfo={seoInfo} />
      <Header {...breadcrumbsProps} {...headerProps} />
      <CustomizerComponent
        name="CMS-GP-HOME-TELETIPO"
        Component={Teletipo}
        componentName="Teletipo"
        componentProps={null}
        skeletonClassName="teletipo-skeleton"
      />
      {banner1 && banner2 && banner3 && (
        <Banner bannerProps={[banner1, banner2, banner3]} />
      )}
      <FeaturedOffer
        featureProps={[offer1, offer2, offer3, offer4]}
        title={offerTitle}
      />

      <DisplayOnViewportIntersection options={{ rootMargin: "500px" }}>
        <CustomizerComponentB
          name="CMS-GP-HOME-EXPERIENCIA-MOVISTAR"
          Component={Ecosystem}
          componentProps={creativityData13}
          componentName="Ecosystem"
          skeletonClassName="skeleton-ecosystem"
        />
      </DisplayOnViewportIntersection>
      <DisplayOnViewportIntersection options={{ rootMargin: "500px" }}>
        <DeviceSection {...[creativityData10, dispoData]} />
      </DisplayOnViewportIntersection>

      <DisplayOnViewportIntersection options={{ rootMargin: "500px" }}>
        <CustomizerComponent
          name="CMS-GP-HOME-SLIDER-CONTENIDOS"
          Component={StreamingPlatformsSection}
          componentName="StreamingPlatformSection"
          componentProps={sliderContenidos}
        />
      </DisplayOnViewportIntersection>
      <CustomizerComponent
        name="CMS-GP-HOME-VENTAJAS"
        Component={AdvantagesSection}
        componentName="StreamingPlatformSection"
        componentProps={advantages}
      />
      <Footer footerProps={footerProps} />
    </>
  );
};

export default Home;

export const getStaticProps = wrapper.getStaticProps(async ({ store }) => {
  const modules = await Promise.all([
    await import("@gerenciatd/next13.adabyron.misc.get-static-content"),
    await import("@gerenciatd/next13.normalizers.components-header.sections"),
    await import(
      "@gerenciatd/next13.normalizers.components-header.breadcrumbs"
    ),
    await import("@/bit/reducers/next13.reducers.header-reducer"),
    await import("@gerenciatd/next13.adabyron.custo.get-seo"),
    await import("@gerenciatd/next13.adabyron.custo.get-by-name"),
  ]);
  const getStaticContent = modules[0].default;
  const getHeaderSections = modules[1].default;
  const getBreadcrumbs = modules[2].default;
  const headerActions = modules[3].actions;
  const getSeo = modules[4].default;

  const getByName = modules[5].default;

  const context = store.getState().main.context;

  // BANNER
  const banner1 = await getByName({
    name: "CMS-GP-HOME-HERO-1",
    context,
    build: true,
    kind: "activity",
  });

  const banner2 = await getByName({
    name: "CMS-GP-HOME-HERO-2",
    context,
    build: true,
    kind: "activity",
  });

  const banner3 = await getByName({
    name: "CMS-GP-HOME-HERO-3",
    context,
    build: true,
    kind: "activity",
  });

  const offerTitle = await getByName({
    name: "CMS-GP-HOME-OFERTAS-DESTACADAS-TITULO",
    context,
    build: true,
    kind: "activity",
  });

  const offer1 = await getByName({
    name: "CMS-GP-HOME-OFERTAS-DESTACADAS-1",
    context,
    build: true,
    kind: "activity",
  });

  const offer2 = await getByName({
    name: "CMS-GP-HOME-OFERTAS-DESTACADAS-2",
    context,
    build: true,
    kind: "activity",
  });

  const offer3 = await getByName({
    name: "CMS-GP-HOME-OFERTAS-DESTACADAS-3",
    context,
    build: true,
    kind: "activity",
  });

  const offer4 = await getByName({
    name: "CMS-GP-HOME-OFERTAS-DESTACADAS-4",
    context,
    build: true,
    kind: "activity",
  });

  const sliderContenidos = await getByName({
    name: "CMS-GP-HOME-SLIDER-CONTENIDOS",
    context,
    build: true,
    kind: "activity",
  });

  // VENTAJAS
  const advantages = await getByName({
    name: "CMS-GP-HOME-VENTAJAS",
    context,
    build: true,
    kind: "activity",
  });

  // MINISLIDER DISPOSITIVOS
  const creativityData10 = await getByName({
    name: "CMS-GP-HOME-MOVILES-DISPOSITIVOS-LIBRES",
    context,
    build: true,
    kind: "activity",
  });
  const dispoData = await getByName({
    name: "CMS-GP-HOME-MOVILES-DISPOSITIVOS-R2R",
    context,
    build: true,
    kind: "activity",
  });

  const creativityData13 = await getByName({
    name: "CMS-GP-HOME-EXPERIENCIA-MOVISTAR",
    context,
    build: true,
    kind: "activity",
  });

  const seoInfo = await getSeo({
    context,
    location: "www.movistar.es/particulares",
  });

  // HEADER
  // HEADER USUAL PROPS
  const urlBreadcrumbs = "/static/json/header/breadcrumbs.json";
  const breadcrumbsInfoJson = await getStaticContent({
    resourcePath: urlBreadcrumbs,
    context,
  });
  const url = "";
  const breadcrumbsProps = getBreadcrumbs(breadcrumbsInfoJson, url);
  const headerInfoJson = await getStaticContent({
    resourcePath: "/static/json/header/header_plan_r.json",
    context,
  });
  // HEADER REDUX PROPS
  const headerProps = getHeaderSections(headerInfoJson, breadcrumbsProps);
  store.dispatch(headerActions.setupHeaderProps(headerProps));

  // FOOTER USUAL PROPS
  const footerProps = await getStaticContent({
    resourcePath: "/static/json/footer/footer_Plan_R.json",
    context,
  });
  store.dispatch(END);
  await store.sagaTask.toPromise();
  return {
    props: {
      seoInfo,
      headerProps,
      breadcrumbsProps,
      footerProps,
      // creatividades
      dispoData,
      banner1,
      banner2,
      banner3,
      offerTitle,
      offer1,
      offer2,
      offer3,
      offer4,
      sliderContenidos,
      creativityData10,
      creativityData13,
      advantages,
    },
  };
});
